import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

function SidebarItem({ data, index, closeMenu, badgeCount = 0, childBadges = {} }) {
  const location = useLocation();

  const [openIndex, setOpenIndex] = useState(null);
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const isChildActive = data?.children?.some(child => 
    location.pathname === child.link
  );
  return (
    <>
      {data?.children?.length ? (
        <li
          className={`my-px space-y-1 w-full h-12 transition-all duration-1000 overflow-hidden ${
            openIndex === index && "h-auto"
          }`}
        >
          <h3
            onClick={() => toggleAccordion(index)}
            className={`flex flex-row items-center justify-between cursor-pointer h-12 px-4 rounded-lg ${
              isChildActive 
                ? "bg-gray-100 text-green-600 dark:bg-gray-800 dark:text-green-400"
                : "text-gray-500 dark:text-gray-100 hover:bg-green-50 hover:text-green-600 dark:hover:bg-green-900/20 dark:hover:text-green-400"
            }`}
          >
            <div className="flex items-center">
              <span className={`flex items-center justify-center text-lg ${
                isChildActive 
                  ? "text-green-600 dark:text-green-400"
                  : "text-gray-500 dark:text-gray-100"
              }`}>
                {data?.icon || ""}
              </span>
              <span className="mx-3">{data?.name}</span>
              {badgeCount > 0 && (
                <span className="inline-flex items-center justify-center text-[10px] font-bold text-white bg-red-500 min-w-5 h-5 px-1 rounded-full leading-none">
                  {badgeCount}
                </span>
              )}
            </div>
            <span className="text-sm">
              {openIndex === index ? <IoChevronUp /> : <IoChevronDown />}
            </span>
          </h3>
          {data?.children?.map((item, idx) => {
            const childBadge = childBadges?.[item.link] || 0;
            return (
              <NavLink
                key={idx}
                to={item?.link}
                onClick={closeMenu}
                className={`${
                  [`${item?.link}`].includes(location.pathname)
                    ? "flex flex-row items-center h-12 px-4 rounded-lg bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
                    : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-gray-100 hover:bg-green-50 hover:text-green-600 dark:hover:bg-green-900/20 dark:hover:text-green-400"
                }`}
              >
                <span className="mx-3">{item.name}</span>
                {childBadge > 0 && (
                  <span className="inline-flex items-center justify-center text-[10px] font-bold text-white bg-red-500 min-w-5 h-5 px-1 rounded-full leading-none mr-auto">
                    {childBadge}
                  </span>
                )}
              </NavLink>
            );
          })}
        </li>
      ) : (
        <li className="my-px w-full">
          <NavLink
            onClick={closeMenu}
            to={data?.link}
            className={`${
              [`${data?.link}`].includes(location.pathname)
              ? "flex flex-row items-center h-12 px-4 rounded-lg bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300"
              : "flex flex-row items-center h-12 px-4 rounded-lg text-gray-500 dark:text-gray-100 hover:bg-green-50 hover:text-green-600 dark:hover:bg-green-900/20 dark:hover:text-green-400"
            }`}
          >
            <span className={`flex items-center justify-center text-lg ${
              [`${data?.link}`].includes(location.pathname)
                ? "text-green-600 dark:text-green-300"
                : "text-gray-500 dark:text-gray-100"
            }`}>
              {data?.icon || ""}
            </span>
            <span className="mx-3">{data?.name}</span>
          </NavLink>
        </li>
      )}
    </>
  );
}

export default SidebarItem;
